"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderControls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _svgFetcher = _interopRequireDefault(require("../../../utils/svgFetcher"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SliderControlIcon = (0, _svgFetcher["default"])('dls-icon-right-filled', 'dls');
var createHandleKeyDown = function createHandleKeyDown(styles) {
  return function (evt) {
    var event = evt;
    var key = event.key,
      target = event.target;
    var classList = [styles.sliderControlsPrev, styles.sliderControlsNext, styles.indicatorItem];
    var classNameVal = String((target || {}).className || '').toLowerCase();
    var clsNameMatch = classList.find(function (item) {
      return classNameVal.indexOf(item.toLowerCase()) > -1;
    });
    if (!!clsNameMatch && (key === ' ' || key === 'Enter')) {
      if (typeof target.click === 'function') {
        event.stopPropagation();
        event.preventDefault();
        setTimeout(function () {
          target.click();
        }, 20);
      }
    }
  };
};
var SliderControls = exports.SliderControls = function SliderControls(_ref) {
  var numSlides = _ref.numSlides,
    styles = _ref.styles,
    PrevIcon = _ref.PrevIcon,
    NextIcon = _ref.NextIcon,
    nextSlide = _ref.nextSlide,
    prevSlide = _ref.prevSlide,
    position = _ref.position,
    setPosition = _ref.setPosition,
    hideFirstLastArrow = _ref.hideFirstLastArrow,
    hideAllArrows = _ref.hideAllArrows,
    afterPositionChange = _ref.afterPositionChange;
  var lastPosition = (0, _react.useRef)(position);
  var indicatorOnClick = function indicatorOnClick(index) {
    if (lastPosition.current === numSlides - 1 && index === 0) {
      afterPositionChange({
        positionChangedBy: 1
      });
    } else {
      afterPositionChange({
        positionChangedBy: index - lastPosition.current
      });
    }
    setPosition(index);
  };
  (0, _react.useEffect)(function () {
    lastPosition.current = position;
  }, [position]);
  return numSlides > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    onKeyDown: createHandleKeyDown(styles),
    className: styles.sliderControls
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.sliderControlsPrev, _defineProperty({}, styles.hideArrow, hideAllArrows || hideFirstLastArrow && position === 0)),
    onClick: prevSlide,
    role: "button",
    "aria-label": "previous",
    tabIndex: "0"
  }, PrevIcon), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.indicatorContainer
  }, Array.from({
    length: numSlides
  }, function (_, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      role: "button",
      tabIndex: "0",
      "aria-pressed": index === position,
      "aria-hidden": index !== position,
      "aria-label": "slide ".concat(index + 1),
      onClick: function onClick() {
        return indicatorOnClick(index);
      },
      className: (0, _classnames["default"])(styles.indicatorItem, _defineProperty({}, styles.indicatorItemActive, index === position)),
      key: index
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.sliderControlsNext, _defineProperty({}, styles.hideArrow, hideAllArrows || hideFirstLastArrow && position === numSlides - 1)),
    onClick: nextSlide,
    role: "button",
    "aria-label": "next",
    tabIndex: "0"
  }, NextIcon));
};
SliderControls.propTypes = {
  numSlides: _propTypes["default"].number.isRequired,
  nextSlide: _propTypes["default"].func.isRequired,
  prevSlide: _propTypes["default"].func.isRequired,
  position: _propTypes["default"].number.isRequired,
  setPosition: _propTypes["default"].func.isRequired,
  NextIcon: _propTypes["default"].node,
  PrevIcon: _propTypes["default"].node,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  hideFirstLastArrow: _propTypes["default"].bool,
  hideAllArrows: _propTypes["default"].bool,
  afterPositionChange: _propTypes["default"].func
};
SliderControls.defaultProps = {
  styles: {},
  NextIcon: SliderControlIcon,
  PrevIcon: SliderControlIcon,
  hideFirstLastArrow: false,
  hideAllArrows: false,
  afterPositionChange: function afterPositionChange() {}
};